import UOM from './lookups/UOM.json';
import Tax from './lookups/Tax.json';
import Bank from './lookups/Bank.json';
import PNLAccount from './lookups/PNLAccount.json';
import INTSalePlatform from './lookups/INTSalePlatform.json';
import IntegrationProviders from './lookups/IntegrationProviders.json';

var data = [];

data.push({ name: 'UOM', value: UOM });
data.push({ name: 'Tax', value: Tax });
data.push({ name: 'Bank', value: Bank });
data.push({ name: 'PNLAccount', value: PNLAccount });
data.push({ name: 'INTSalePlatform', value: INTSalePlatform });
data.push({ name: 'IntegrationProviders', value: IntegrationProviders });

export default data;
